// extracted by mini-css-extract-plugin
export default {"headerModal":"ShowWFModal_headerModal__OT3ZM","bodyModal":"ShowWFModal_bodyModal__HPNNB","botaoLink":"ShowWFModal_botaoLink__9lpID","descricao_wf":"ShowWFModal_descricao_wf__xKOQv"};